import React from 'react';
import { Location } from '@reach/router';
import { LogoIconElement, HeaderDiv, Logo, UlNav, LiNav, Line, LogoSpan, Button, HeaderWrapper } from './elements';
import { useStaticQuery, graphql, Link } from "gatsby";
import { Margin, Locale } from '@helpers';

export const Header = ({ scrollDirection, scrollY, t, i18n, pageContext }) => {

  const file = useStaticQuery(graphql`
    {
      zip: allFile(filter: {relativeDirectory: {eq: "download"}}) {
        nodes {
          publicURL
          name
        }
      },
      site: site {
        siteMetadata {
          defaultLanguage
        }
      }
    }
  `)

  const getLocaleBrandbook = (lang) => {
    const zip = file.zip.nodes.filter(file => file.name.split('_')[1] === lang)[0];

    return zip.publicURL;
  }

  const getUrl = (path) => {
    const defaultLang = file.site.siteMetadata.defaultLanguage;
    
    if(pageContext.lang === defaultLang) return `${path}`
    else return `/${pageContext.lang}${path}`
  }
  
  return (
    <HeaderWrapper hide={scrollY > -100 && scrollDirection === 'down'}>
      <div className='container'>
        <HeaderDiv>
          <Link to={getUrl('/')}>
            <Logo>
              <LogoIconElement />
              <Line>|</Line>
              <LogoSpan>{t("Brand")}</LogoSpan>
            </Logo>
          </Link>
          <Location>
            {props => (
              <UlNav>
                <LiNav colored={props.location.pathname === getUrl('/') ? true : false}>
                  <Link to={getUrl('/')}>{t("About us")}</Link>
                </LiNav>
                <LiNav colored={props.location.pathname === getUrl('/content/') ? true : false}>
                  <Link to={getUrl('/content/')}>{t("Content")}</Link>
                </LiNav>
                <LiNav colored={props.location.pathname === getUrl('/logo/') ? true : false}>
                  <Link to={getUrl('/logo/')}>{t("Logo")}</Link>
                </LiNav>
                <LiNav colored={props.location.pathname === getUrl('/colors/') ? true : false}>
                  <Link to={getUrl('/colors/')}>{t("Colors")}</Link>
                </LiNav>
                <LiNav colored={props.location.pathname === getUrl('/typography/') ? true : false}>
                  <Link to={getUrl('/typography/')}>{t("Typography")}</Link>
                </LiNav>
                <LiNav colored={props.location.pathname === getUrl('/branding/') ? true : false}>
                  <Link to={getUrl('/branding/')}>{t("Style & Branding")}</Link>
                </LiNav>
              </UlNav>
            )}
          </Location>
          <Margin marginLeft='89px'>
            <a href={getLocaleBrandbook(i18n.language)} download className='button'>
              <Button>
                {t("Download")}
              </Button>
            </a>
          </Margin>
          <Locale pageContext={pageContext} getUrl={getUrl}/>
        </HeaderDiv>
      </div>
    </HeaderWrapper>
  );
};
